import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';

/**
 * Entry point
 */
ReactDOM.render(<Root />, document.getElementById('root'));
